var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('satac-splash'),_c('satac-details'),_c('timetable'),_c('tables')],1)}
var staticRenderFns = []

export { render, staticRenderFns }